// extracted by mini-css-extract-plugin
export default {"container":"BNaAm","details":"Dr74r"};